<template>
  <CHeader position="sticky" class="mb-4">
    <screen-short
      v-if="screenshotStatus"
      @destroy-component="destroyComponent"
      @get-image-data="getImg"
    >
    </screen-short>
    <CContainer fluid>
      <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')">
        <CIcon icon="cil-menu" size="lg" />
      </CHeaderToggler>
      <CHeaderBrand class="mx-auto d-lg-none" to="/">
        <CIcon :icon="logo" height="48" alt="Logo" />
      </CHeaderBrand>
      <CHeaderNav class="d-none d-md-flex me-auto">
        <CNavItem>
          <CNavLink href="/dashboard"> Dashboard </CNavLink>
        </CNavItem>
      </CHeaderNav>
      <CHeaderNav class="mx-2">
        <CNavItem>
          <!-- <button
            type="button"
            class="icon-button1 mr-1"
            @click="abreListaPedidos(item.data)"
          >
            <span class="material-icons"
              ><CIcon class="mx-2" icon="cil-bell" size="lg"
            /></span>
            <span class="icon-button__badge">{{ 4 }}</span>
          </button> -->
          <b-dropdown
            size="lg"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
            class="icon-button1"
          >
            <template #button-content>
              <span class="material-icons"
                ><CIcon class="" icon="cil-bell" size="xl"
              /></span>
              <span
                class="icon-button__badge1"
                v-if="Object.keys(pedidosNaoEnviados).length > 0"
                >{{ Object.keys(pedidosNaoEnviados).length }}</span
              >
            </template>

            <b-dropdown-item
              v-for="campanha in Object.keys(this.pedidosNaoEnviados)"
              :key="campanha"
              :href="`/pedidos/${campanha}#/pedidos/${campanha}`"
              >{{
                `(${this.pedidosNaoEnviados[campanha].qtd_pedidos}) ${this.pedidosNaoEnviados[campanha].nome_campanha}`
              }}</b-dropdown-item
            >
          </b-dropdown>
          <!-- <CNavLink href="#">
            <CIcon class="mx-2" icon="cil-bell" size="lg" />
          </CNavLink> -->
        </CNavItem>
        <!-- <CNavItem>
          <CNavLink>
            <CIcon class="mx-2" icon="cil-settings" size="lg" @click="print" />
          </CNavLink>
        </CNavItem> -->
      </CHeaderNav>
    </CContainer>
    <CHeaderDivider />
    <CContainer fluid>
      <AppBreadcrumb />
      <AppHeaderDefault />
    </CContainer>
  </CHeader>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'
import moment from 'moment'
import VueJwtDecode from 'vue-jwt-decode'
import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDefault from './AppHeaderDefault'
// import Auth from '../layouts/Auth.vue'
import { logo } from '@/assets/brand/logo'
import { ref } from 'vue'

export default {
  name: 'AppHeader',
  components: {
    AppBreadcrumb,
    AppHeaderDefault,
  },
  data() {
    return {
      timerEnabled: true,
      timerCount: 0,
    }
  },
  setup() {
    const store = useStore()
    const screenshotStatus = ref(false)
    const destroyComponent = function (status) {
      screenshotStatus.value = status
    }

    return {
      user: computed(() => store.state.user),
      pedidosNaoEnviados: computed(() => store.state.pedidosNaoEnviados),
      logo,
      screenshotStatus,
      destroyComponent,
    }
  },
  methods: {
    print() {
      this.screenshotStatus = !this.screenshotStatus
    },
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        setTimeout(() => {
          this.timerCount--
        }, 1000)
      }
    },
    timerCount: {
      handler() {
        const { exp } = VueJwtDecode.decode(localStorage.token)
        var tempo = exp - (new Date().getTime() + 1) / 1000
        var duration = moment.duration(tempo, 'seconds')
        setTimeout(() => {
          this.timerCount = duration.minutes() + ':' + duration.seconds()
        }, 1000)
        if (exp < (new Date().getTime() + 1) / 1000) {
          this.$toast.warning('Sua sessão expirou!')
          this.$router.push({
            name: 'Login',
          })
        }
      },
      immediate: true,
    },
  },
}
</script>
<style scopped>
.icon-button1 {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  color: #333333;
  background: transparent;
  border: none;
  outline: none;
  border-radius: 50%;
}
.icon-button:hover {
  cursor: pointer;
}
.icon-button:active {
  background: #cccccc;
}
.icon-button__badge1 {
  position: absolute;
  top: 5px;
  right: 15px;
  width: 20px;
  height: 20px;
  background: red;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 15px;
}
</style>
